import { HsMatrix3 } from '../../../math-new/objects/matrix3.class';
import { HsVector3 } from '../../../math-new/objects/vector3.class';
import type { HsHypersceneTypes } from '../../../math-new/types/hyperscene-types.type';
import { HsLight } from './light.class';

export class HsDirectionalLight extends HsLight {
  private readonly direction: HsVector3 = HsVector3.makeUnitVectorY();
  private readonly rotatedDirection: HsVector3 = HsVector3.makeUnitVectorY();

  static readonly #matrix3Temp1: HsMatrix3 = HsMatrix3.makeIdentityMatrix();

  public setDirection(direction: HsHypersceneTypes.Array3): void {
    this.direction.setFromArray(direction).normalize();
  }

  public getDynamicDirection(): HsHypersceneTypes.Array3 {
    HsDirectionalLight.#matrix3Temp1.setFromMatrix4(this.worldMatrix.values);
    this.rotatedDirection.copy(this.direction).applyMatrix3(HsDirectionalLight.#matrix3Temp1.values);
    return this.rotatedDirection.values;
  }
}
